import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class IconModule {
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer
  ) {
    matIconRegistry.addSvgIcon(
      'cis_home',
      sanitizer.bypassSecurityTrustResourceUrl('assets/svg/icons/home_ic.svg')
    );
  }
}
